import React, { useState } from 'react';
import {
  Typography,
  Switch,
  FormGroup,
  FormControlLabel,
  Stack,
} from '@mui/material';
import HolographicCard from '../../../components/common/HolographicCard.tsx';
import GradientText from '../../../components/common/GradientText.tsx';

interface NotificationSettingsProps {
  settings: {
    emailNotifications: boolean;
    pushNotifications: boolean;
    soundAlerts: boolean;
    weeklyDigest: boolean;
  };
  onUpdate: (type: string, data: any) => Promise<void>;
}

const NotificationSettings: React.FC<NotificationSettingsProps> = ({
  settings,
  onUpdate,
}) => {
  const [formData, setFormData] = useState(settings);

  const handleChange = async (key: keyof typeof formData) => {
    const newData = {
      ...formData,
      [key]: !formData[key],
    };
    setFormData(newData);
    await onUpdate('notifications', newData);
  };

  const switchStyles = {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#8a2be2',
      '&:hover': {
        backgroundColor: 'rgba(138, 43, 226, 0.1)',
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#8a2be2',
    },
  };

  return (
    <HolographicCard>
      <GradientText variant="h6" gradient="primary" gutterBottom>
        Notification Settings
      </GradientText>
      <Stack spacing={2}>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={formData.emailNotifications}
                onChange={() => handleChange('emailNotifications')}
                sx={switchStyles}
              />
            }
            label={
              <Typography sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                Email Notifications
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Switch
                checked={formData.pushNotifications}
                onChange={() => handleChange('pushNotifications')}
                sx={switchStyles}
              />
            }
            label={
              <Typography sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                Push Notifications
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Switch
                checked={formData.soundAlerts}
                onChange={() => handleChange('soundAlerts')}
                sx={switchStyles}
              />
            }
            label={
              <Typography sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                Sound Alerts
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Switch
                checked={formData.weeklyDigest}
                onChange={() => handleChange('weeklyDigest')}
                sx={switchStyles}
              />
            }
            label={
              <Typography sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                Weekly Digest
              </Typography>
            }
          />
        </FormGroup>
      </Stack>
    </HolographicCard>
  );
};

export default NotificationSettings; 